const i18nConfig = {
  locales: ['pt-BR', 'en-US', 'es-ES', 'fr-FR', 'ar'],
  defaultLocale: 'en-US',
  loader: false,
  pages: { '*': ['common'] },
  loadLocaleFrom: (locale, namespace) => import(`./src/translations/${locale}/${namespace}.json`).then((m) => m.default)
};

module.exports = i18nConfig;
